import type { TipsContent } from "@/app/components/Tips";

const skills: TipsContent = {
	summary:
		"A few keywords bullet points (up to 12, three columns) or a brief listing of your most notable skills, education, and experiences as they relate to your target opportunities.",
	tips: [
		"Highlighting particular skills or specialized training you possess can provide readers with additional information about your capabilities.",
		"Only include skills that are both relevant to the role and those recruiters won't reasonably assume you already have.",
		"If you possess anything more than basic proficiency with a common piece of software, you should highlight it to differentiate your skillset.",
		{
			text: "Use following designation to indicate your skill level with a certain piece of software in order of increasing proficiency:",
			items: [
				"Intermediate (top 50% expertise)",
				"Advanced (top 75% expertise)",
				"Expert (top 95% expertise)",
				"Ex. Adobe photoshop, Salesforce, Excel (Advanced)",
			],
		},
		{
			text: "Also a place of highlighting any languages you may have proficiency in.",
			items: ["Languages: Spanish (Business), Arabic (Fluent)"],
		},
	],
};

export default skills;
